module.exports = __webpack_public_path__ + "img/chadle_adv_23.320a512d.png";